import { InvoiceItemData, ProviderDetails } from '../../../datasource';
import { CornerstoneInvoiceItem } from './CornerstoneInvoiceItem';
import { DatasourceFullSiteInfo } from '../../../datasource/sites';

export class CornerstoneInvoiceItemWithVariantDetail extends CornerstoneInvoiceItem {
    difference?: InvoiceItemData = {} as InvoiceItemData;

    providers: ProviderDetails[];

    sites?: DatasourceFullSiteInfo[];

    variants: CornerstoneInvoiceItem[] = [];
}
